import React from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import { formatPen } from "../../../../utils/finance/format";


export function FinanceYearlyComparisonTable({ data, yearA, yearB }) {
  if (!data) return null;

  const rows = [
    { key: "sales", label: "Ventas" },
    { key: "payments", label: "Pagos" },
    { key: "expenses", label: "Gastos" },
    { key: "cashflow", label: "Cashflow" },
    { key: "result", label: "Resultado" },
  ];

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Concepto</TableCell>
            <TableCell align="right">{yearA}</TableCell>
            <TableCell align="right">{yearB}</TableCell>
            <TableCell align="right">Δ Absoluto</TableCell>
            <TableCell align="right">Δ %</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((r) => {
            const a = Number(data.years[yearA][r.key]);
            const b = Number(data.years[yearB][r.key]);
            const delta = data.delta[r.key];

            return (
              <TableRow key={r.key}>
                <TableCell>{r.label}</TableCell>
                <TableCell align="right">{formatPen(a)}</TableCell>
                <TableCell align="right">{formatPen(b)}</TableCell>
                <TableCell align="right">
                  {formatPen(delta.abs)}
                </TableCell>
                <TableCell align="right">
                  {delta.pct !== null ? `${Number(delta.pct).toFixed(1)}%` : "—"}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
